import { Component } from "@angular/core";

/**
 * Presentational fragment for the static "What to know before your exam" block
 * that appears identically inside the General and Tomorrow appointment-reminder
 * email cards.
 *
 * Uses an attribute selector on a <tr> so the host element IS the table row the
 * original markup used (no extra DOM node is introduced and the rendered output
 * stays visually identical). The content is fully static.
 */
@Component({
  selector: "tr[appExamTips]",
  templateUrl: "./notification-exam-tips.component.html",
})
export class NotificationExamTipsComponent {}
